module.exports = __webpack_public_path__ + "img/tuceng1122.266880a5.png";